import { api } from "../lib/api";

export const listForProspect = (
  prospectId
) =>
  api
    .get(
      `/prospects/${encodeURIComponent(
        prospectId
      )}/appointments`
    )
    .then(
      (response) => response.data
    );

export const create = (
  prospectId,
  payload
) =>
  api
    .post(
      `/prospects/${encodeURIComponent(
        prospectId
      )}/appointments`,
      payload
    )
    .then(
      (response) => response.data
    );

export const update = (
  appointmentId,
  payload
) =>
  api
    .put(
      `/prospect-appointments/${encodeURIComponent(
        appointmentId
      )}`,
      payload
    )
    .then(
      (response) => response.data
    );

export const remove = (
  appointmentId
) =>
  api
    .delete(
      `/prospect-appointments/${encodeURIComponent(
        appointmentId
      )}`
    )
    .then(
      (response) => response.data
    );
